export const EVENT_READY = 'plugin:AmpEventsSources:ready';